// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"f0ea52fb","417":"58a0c106","532":"e1195930","564":"0251013b"}[chunkId] + ".chunk.css";
};